import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { dataUpdatePassword } from '../models/dataUpdatePassword';
import { userAccountData } from '../models/userAccountData';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

const httpOptionData = {
  headers: new HttpHeaders({
   // 'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  
  url = environment.baseUrl+ '/api/user';


  constructor(private http: HttpClient) {}

  getUsers(page: number, numReg: number): Observable<any> {
    const body = { page, numReg };
    return this.http.post<any>(this.url + '/UsersLst', body, httpOption);
  }

  getDeportistas(page: number, numReg: number, searchString:string,ordenamiento:string, disciplinaId?: string): Observable<any> {
    const body = { page, numReg,searchString, disciplinaId, ordenamiento };
    return this.http.post<any>(this.url + '/UsersDeportistasLst', body, httpOption);
  }

  getDeportistasLiga(page: number, numReg: number, searchString:string, disciplinaId?: string): Observable<any> {
    const body = { page, numReg,searchString, disciplinaId };
    return this.http.post<any>(this.url + '/UsersDeportistasLigaLst', body, httpOption);
  }

  getDeportistasAltoRendimiento(page: number, numReg: number, searchString:string, disciplinaId?: string, empresaId?:string): Observable<any> {
    const body = { page, numReg,searchString, disciplinaId, empresaId };
    return this.http.post<any>(this.url + '/UsersAltoRendimientoLst', body, httpOption);
  }

  getDeportistasEliminados(page: number, numReg: number, searchString:string,ordenamiento:string, disciplinaId?: string): Observable<any> {
    const body = { page, numReg,searchString, disciplinaId, ordenamiento };
    return this.http.post<any>(this.url + '/UsersDeportistasEliminadosLst', body, httpOption);
  }

  getEmpleados(page: number, numReg: number, searchString:string): Observable<any> {
    const body = { page, numReg,searchString };
    return this.http.post<any>(this.url + '/UsersEmpleadosLst', body, httpOption);
  }

  getHojaUsuario(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetHojaUsuario', obj, httpOption);
  }
  getHojaUsuarioAdmin(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetHojaUsuarioAdmin', obj, httpOption);
  }

  getTotalUsers(): Observable<any> {
    const body = {};
    return this.http.post<any>(this.url + '/TotalUsers', body, httpOption);
  }

  gerUsersObj(page: number, numReg: number, searchString:string): Observable<any> {
    const body = { page, numReg, searchString };
    return this.http.post<any>(this.url + '/gerUsersObj', body, httpOption);
  }

  crearUsuario(usuario:any): Observable<boolean> {
    const body = usuario;
    console.log('/CrearUsuario');
    console.log(body);
    return this.http.post<boolean>(this.url + '/CreateUser', body, httpOption);
  }

  EditarUsuario(usuario:any): Observable<boolean> {
    const body = usuario;
    console.log('/CrearUsuario');
    console.log(body);
    return this.http.post<boolean>(this.url + '/EditUser', body, httpOption);
  }

  EditarUsuarioPorLiga(usuario:any): Observable<boolean> {
    const body = usuario;
    return this.http.post<boolean>(this.url + '/EditUserPorLiga', body, httpOption);
  }

  EliminarUsuario(usuario:any): Observable<boolean> {
    const body = usuario;
    console.log('/DeleteUser');
    console.log(body);
    return this.http.post<boolean>(this.url + '/DeleteUser', body, httpOption);
  }

  ReactivarUsuario(usuario:any): Observable<boolean> {
    const body = usuario;
    return this.http.post<boolean>(this.url + '/ReactivarUser', body, httpOption);
  }

  ActualizarPassword(usuario:dataUpdatePassword): Observable<boolean> {
    const body = usuario;
    console.log('/RestorePwd');
    console.log(body);
    return this.http.post<boolean>(this.url + '/RestorePwd', body, httpOption);
  }

  RestorePwdByEmail(emailUser:string): Observable<boolean> {
    const body: dataUpdatePassword= {
      email:emailUser,
      cadenaRecuperarPassword:"AAAAA",
      id:'00000000-0000-0000-0000-000000000000',
      password:'AAAAA'
    };
    console.log('/RestorePwd');
    console.log(body);
    return this.http.post<boolean>(this.url + '/RestorePwdByEmail', body, httpOption);
  }

  GetUserProfileData(): Observable<userAccountData> {
    console.log('/GetUserProfileData');
    return this.http.post<userAccountData>(this.url + '/GetUserProfileData', {}, httpOption);
  }

  EditUserProfile(usuario:userAccountData): Observable<boolean> {
    usuario.id='00000000-0000-0000-0000-000000000000';
    const body = usuario;
    console.log('/EditUserProfile');
    console.log(body);
    return this.http.post<boolean>(this.url + '/EditUserProfile', body, httpOption);
  }
  
  createEmpleado(usuario:any): Observable<boolean> {
    const body = usuario;
    console.log('/CreateEmpleado');
    console.log(body);
    return this.http.post<boolean>(this.url + '/CreateEmpleado', body, httpOption);
  }

  editarEmpleado(usuario:any): Observable<boolean> {
    const body = usuario;
    console.log('/CreateDeportista');
    console.log(body);
    return this.http.post<boolean>(this.url + '/EditarEmpleado', body, httpOption);
  }
  
  createDeportista(usuario:any): Observable<number> {
    const body = usuario;
    console.log('/CreateDeportista');
    console.log(body);
    return this.http.post<number>(this.url + '/CreateDeportista', body, httpOption);
  }

  editarDeportista(usuario:any): Observable<boolean> {
    const body = usuario;
    console.log('/EditarDeportista');
    console.log(body);
    return this.http.post<boolean>(this.url + '/EditarDeportista', body, httpOption);
  }

  createAdministradorEmpresa(usuario:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/CreateAdministradorEmpresa', usuario, httpOption);
  }
  
  editarDisciplinaUsuario(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/EditarDisciplinaUsuario', obj, httpOption);
  }
  
  getDetalleUsuario(id:string): Observable<any> {
    return this.http.post<any>(this.url + '/GetDetalleUsuario',{id}, httpOption);
  }

  setDetalleUsuario(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/SetDetalleUsuario', obj, httpOption);
  }

  getDeportistasPorOrdenCompra(page: number, numReg: number, searchString:string, ordenCompraId:string, filtro: number,disciplinaId?: string): Observable<any> {
    const body = { page, numReg,searchString,ordenCompraId,filtro, disciplinaId };
    return this.http.post<any>(this.url + '/UsersDeportistasConOrdenCompraLst', body, httpOption);
  }
  getDeportistasPorOrdenCompraActivos(page: number, numReg: number, searchString:string, ordenCompraId:string, disciplinaId?: string): Observable<any> {
    const body = { page, numReg,searchString,ordenCompraId, disciplinaId };
    return this.http.post<any>(this.url + '/UsersDeportistasConOrdenCompraActivosLst', body, httpOption);
  }

  editarEstadoLiga(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/EditarEstadoLiga', obj, httpOption);
  }

  editarPlanDeUsuario(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/EditarPlanDeUsuario', obj, httpOption);
  }

  actualizarImagen(fileToUpload:any, usrId:string): Observable<boolean> {
    const formData: FormData = new FormData();
    formData.append('usrId',usrId );
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http.post<boolean>(this.url + '/ActualizarImagen', formData, httpOptionData);
  }

  getFotoMini(id:string): Observable<any> {
    return this.http.post<any>(this.url + '/GetFotoMini', {id}, httpOption);
  }

  setIngresoExtraordinario(id:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/SetIngresoExtraordinario', {id}, httpOption);
  }

  listadoAdministradores(id:string): Observable<any> {
    return this.http.post<any>(this.url + '/ListadoAdministradores', {id}, httpOption);
  }

  reenviarEmailActivacion(id:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/ReenviarEmailActivacion', {id}, httpOption);
  }
  
  updateEstadoUsuario(id:string, estado:boolean): Observable<boolean> {
    // const body = { page, numReg, searchString };
     return this.http.post<boolean>(this.url + '/UpdateEstadoUsuario', {id, estado}, httpOption);
   }

   updateEstadoAltorendimiento(id:string, estado:boolean): Observable<boolean>{
    return this.http.post<boolean>(this.url + '/UpdateEstadoAltorendimiento', {id, estado}, httpOption);
   }

   DownloadDeportistas():Observable<Blob> {
    return this.http.post<Blob>(this.url+'/DownloadDeportistas',{}, {responseType: 'blob' as 'json'});
  }
}
